export default __webpack_public_path__ + "static/media/signupimage.652ff852.png";